import {Component} from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';

/**
 * スピナー単体
 * スピナーだして、画面ロックする時の、スピナーの中身
 *
 * サンプル
 * @see https://material.angular.io/components/progress-spinner/examples
 *
 *
 * @title Basic progress-spinner
 */
@Component({
	selector: 'ViewSpinnerComponent',
	templateUrl: 'ViewSpinnerComponent.html',
})
export class ViewSpinnerComponent {

	// ぐるぐるの属性をHTML上に設定する用
	public colorVal: ThemePalette = 'primary';
	public modeVal: ProgressSpinnerMode = 'indeterminate'; // 'determinate';
	public valueVal = 50; // determinate だと、この値を変える事で、プログレスバーみたいに動くはず

}
